/**
 * ч.942 (рішення власника): ЄДИНИЙ перелік типів договору — картка договору і
 * швидкий попап на імпорті виписки мали різні списки (3 проти 5). Дзеркало
 * backend `_CONTRACT_TYPE` (schemas/contractor_nested.py).
 */
export type ContractTypeCode =
  | 'WITH_BUYER' | 'WITH_SUPPLIER' | 'WITH_COMMISSIONER' | 'WITH_COMMITTENT' | 'OTHER';

export const CONTRACT_TYPE_LABELS: Record<ContractTypeCode, string> = {
  WITH_BUYER: 'З покупцем',
  WITH_SUPPLIER: 'З постачальником',
  WITH_COMMISSIONER: 'З комісіонером',
  WITH_COMMITTENT: 'З комітентом',
  OTHER: 'Інше',
};
